import Moment from "react-moment";
import { timeLap } from "../../../utils/timeLap";

export default function Checkpoints({ checkpoint }: any) {
  const isOut = checkpoint?.timeout ? true : false;
  return (
    <div className="flex flex-col items-center  flex-shrink-0 mt-2 font-toyota">
      <div className="mt-4 w-auto flex flex-col justify-start items-start px-6">
        <div className="">
          <span className="font-bold text-black">Time In : </span>
          <span className="text-gray-700">
            <Moment format="Do MMM, YYYY hh:mm A">{checkpoint?.timein}</Moment>
          </span>
        </div>
        <div className="">
          <span className="font-bold text-black">Time Out : </span>
          {isOut ? (
            <span className="text-gray-700">
              <Moment format="Do MMM, YYYY hh:mm A">
                {checkpoint?.timeout}
              </Moment>
            </span>
          ) : (
            <span className="text-gray-700">-</span>
          )}
        </div>
      </div>
      <div className="flex justify-center items-center mb-6 mt-2">
        [
        <span
          className={` text-xl mx-2 ${
            isOut ? "text-green-700 " : "text-red-700 "
          }"`}
        >
          {timeLap(checkpoint?.timein, checkpoint?.timeout)}
        </span>
        ]
      </div>
      <div
        className={`border-b-4 w-full ${
          isOut ? "border-green-500" : "border-red-500"
        } `}
      ></div>
      <div
        className={`w-8 h-8  rounded-full -mt-4 ${
          isOut ? "bg-green-600 text-green-600" : "bg-red-600 text-red-600"
        } `}
      >
        -
      </div>
      <div
        className={`font-bold mt-4 mb-8  ${
          isOut ? "text-green-700 " : "text-red-700 "
        }`}
      >
        {checkpoint?.station?.name}
      </div>
    </div>
  );
}
